<template>
  <div class="policy_detail p_t">
    <TopHead title="新闻动态详情"></TopHead>
    <div class="pd_c">
      <div class="f_title l">{{ydInfo.title}}</div>
      <div class="sub d_f ali_c">
        <span class="flex_1">时间：<span>{{ydInfo.createTime.split(' ')[0]}}</span></span>
        <span class="flex_1">浏览<span>{{ydInfo.readTimes}}</span>次</span>
      </div>
      <div class="pdc_c" v-html="ydInfo.contentInfo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PolicyDetail",
    data() {
      return {
        ydInfo:{createTime:''},
      }
    },
    created(){
      this.queryContentByCode();
    },
    methods: {
      //营地动态详情
      queryContentByCode(){
        this.$api.queryContentByCode(this.$route.query.contentCode).then(res => {
          this.ydInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .pd_c{
    .pdc_c{
      ::v-deep img{
        max-width: 100% !important;
        height: auto;
      }
    }
    .sub{
      font-size: 10px;
      font-weight: 500;
      color: #8C8C8C;
      height: 40px;
      line-height: 40px;
      margin-bottom: 19px;
      border-bottom: 1px solid #E5E5E5;
    }
    padding: 20px 13px;
  }
</style>
